(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ImageAPIService', imageAPIService);

    function imageAPIService(HttpService) {
        function getImageUploadS3SignedUrl(type, format) {
            const data = {
                type: type,
                format: format
            };
            return HttpService.get('/Images/ImageUploadSignedUrl?' + $.param(data));
        }

        function getProductThumbnailsS3SignedUrl() {
            return HttpService.get('/Images/ProductThumbnail/SignedUrl');
        }

        return {
            getImageUploadS3SignedUrl: getImageUploadS3SignedUrl,
            getProductThumbnailsS3SignedUrl: getProductThumbnailsS3SignedUrl
        };
    }
})();
